import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import Spinner from "../components/ui/Spinner"; // 🔥 bestehender Spinner wird genutzt

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      // Leerzeichen am Rand (Autovervollstaendigung) gehoeren nie zum Namen.
      await login(username.trim(), password);
      // Navigation erfolgt automatisch durch App.js
    } catch (err) {
      setError(err.message || "Anmeldung fehlgeschlagen");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-secondary-950">
      <form
        onSubmit={handleSubmit}
        className="bg-secondary-900 p-6 rounded-2xl shadow-lg w-80 border border-secondary-800"
      >
        <h2 className="text-2xl font-bold mb-4 text-center text-white">Login</h2>

        {error && (
          <p className="text-status-error mb-3 text-center text-sm">{error}</p>
        )}

        <input
          type="text"
          placeholder="Benutzername"
          // Handy-Tastaturen schreiben sonst das erste Zeichen gross bzw.
          // "korrigieren" den Namen – jeder solche Versuch zaehlte als
          // Fehlversuch im gemeinsamen Kontingent des Betreuer-Logins.
          autoCapitalize="none"
          autoCorrect="off"
          spellCheck={false}
          autoComplete="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="w-full bg-secondary-800 text-white border border-secondary-700 p-2 rounded mb-3 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500"
          required
          disabled={isLoading}
        />

        <input
          type="password"
          placeholder="Passwort"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-secondary-800 text-white border border-secondary-700 p-2 rounded mb-4 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500"
          required
          disabled={isLoading}
        />

        <button
          type="submit"
          disabled={isLoading}
          className={`w-full py-2 rounded font-semibold flex items-center justify-center transition-colors ${
            isLoading
              ? "bg-secondary-700 text-gray-400 cursor-not-allowed"
              : "bg-primary-500 text-secondary-950 hover:bg-primary-600"
          }`}
        >
          {isLoading ? (
            <>
              <Spinner size={4} /> <span className="ml-2">Anmeldung läuft...</span>
            </>
          ) : (
            "Anmelden"
          )}
        </button>
      </form>
    </div>
  );
}
